export const BAG = (count: number) => `bag (${count})`;
